
export const SLACK_CHANNELS = {
  // Frontend logging and alerts
  FE_LOGS: 'fe-logs',
  FE_METRICS: 'fe-metrics',
  FE_AUTH_REDIRECT_LOGS: 'fe-auth-redirect-logs',
  FE_RESET_PASSWORD: 'fe-reset-password',
  FRONTEND_ALERTS: 'frontend-alerts',
  FRONTEND_ALERTS_INTERNAL: 'frontend-alerts-internal',
  E_FRONTEND_ONCALL: 'e-frontend-oncall',

  // Integration channels
  INTEGRATION_ALERTS: '#integration-alerts',
  ONBOARDING_STORES: 'onboarding-stores',

  // Business logic channels
  INACTIVE_CHAIN_ACTIONS: 'inactive-chain-actions',
  MODULE_REQUEST: 'module-request',
  REVIEW_RESPONSE_ALERTS: 'review-response-alerts',
  CHARGEBACK_SUBCATEGORIES_LOGS: 'chargeback-subcategories-logs',

  // Error notification (with hash prefix)
  ERROR_NOTIFICATION: '#error-notification',

  // Legacy or deprecated (with hash prefix - avoid using these)
  FE_LOGS_HASH: '#fe-logs',
} as const

/**
 * Type for all available Slack channels
 */
export type SlackChannel = typeof SLACK_CHANNELS[keyof typeof SLACK_CHANNELS]

/**
 * Helper function to get the appropriate frontend alert channel based on user type
 * @param isInternal - Whether the user is an internal user
 * @returns The appropriate frontend alert channel
 */
export function getFrontendAlertChannel(isInternal: boolean): SlackChannel {
  return isInternal
    ? SLACK_CHANNELS.FRONTEND_ALERTS_INTERNAL
    : SLACK_CHANNELS.FRONTEND_ALERTS
}

/**
 * Get the default channel for general logging
 */
export function getDefaultLogChannel(): SlackChannel {
  return SLACK_CHANNELS.FE_LOGS
}

/**
 * Get the oncall channel for urgent issues
 */
export function getOncallChannel(): SlackChannel {
  return SLACK_CHANNELS.E_FRONTEND_ONCALL
}